import React from 'react';
import { CONTACT_INFO } from '../constants/config';

/**
 * Reusable component for rendering contact links (phone and email)
 * Automatically formats the href and handles proper display
 *
 * @param {string} type - Either 'phone' or 'email'
 * @param {string} label - The text to display for the link
 * @param {string} className - Optional CSS class name
 */
const ContactLink = ({ type, label, className = '' }) => {
  if (type === 'phone') {
    const phoneNumber = CONTACT_INFO.primaryPhone;
    const phoneHref = `tel:${phoneNumber.replace(/\s/g, '')}`;

    return (
      <a href={phoneHref} className={className}>
        {label || phoneNumber}
      </a>
    );
  }

  if (type === 'email') {
    const email = CONTACT_INFO.primaryEmail;
    const emailHref = `mailto:${email}`;

    return (
      <a href={emailHref} className={className}>
        {label || email}
      </a>
    );
  }

  return null;
};

export default ContactLink;
